var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayoutsuccessicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.2842,
    r: 20,
    fill: "#DDFEF8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0002,
    cy: 20.3498,
    r: 8.88889,
    fill: "#049981"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1428 23.0047C18.9528 23.0047 18.7628 22.9347 18.6128 22.7847L16.6628 20.8347C16.3728 20.5447 16.3728 20.0647 16.6628 19.7747C16.9528 19.4847 17.4328 19.4847 17.7228 19.7747L19.1428 21.1947L22.5028 17.8347C22.7928 17.5447 23.2728 17.5447 23.5628 17.8347C23.8528 18.1247 23.8528 18.6047 23.5628 18.8947L19.6628 22.7847C19.5228 22.9247 19.3328 23.0047 19.1428 23.0047Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutsuccessicon);
export default __webpack_public_path__ + "static/media/payoutsuccessicon.2b8750c8923064e9d0cf02d05a135481.svg";
export { ForwardRef as ReactComponent };